import { t } from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { Link } from 'widgets-for-react'
import { setCookie } from '../../cms/blocks/cookiebar.utils.mod'
import { switchLanguageDatalayer } from '../../datalayer'
import { blockInviewHandler } from '../../drupal/rendering/inview_utils.mod'
import { titleSplit } from '../utils/helpers'
import { allLanguages, localeISOcodes, localeTranslations, oldSites } from '../utils/history.mod'

//TODO: CHECK IF THIS IS USED??
export const SelectLocale = (): JSX.Element => (
  <>
    <InView
      as="header"
      onChange={(inView) => blockInviewHandler('header', inView, 'io-header', 'inview')}
      triggerOnce={true}
      threshold={0}
      id="io-header"
      className="header"
    >
      <div className="header__inner">
        <div className="header__toolbar">
          <div className="header__logo-toggler">
            <Link className="header__logo" to={'/'}>
              <span className="sr-text">{t('Header:returnToHome')}</span>
              <img src="/images/logo--color.svg" alt="" />
            </Link>
          </div>
        </div>
      </div>
    </InView>

    <main id="a11y-main" className="main main--locales">
      <div className="main__inner">
        <article className="page">
          <div className="page__inner">
            <InView
              as="header"
              onChange={(inView) => blockInviewHandler('pageHeader', inView, 'io-page-header', 'inview')}
              triggerOnce={true}
              threshold={0}
              id="io-page-header"
              className="pageheader pageheader--text cf"
            >
              <div className="pageheader__inner bg--green-400">
                <div className="pageheader__title container container--m gutter--3-5">
                  <h1 className="title--l">{titleSplit(t('SelectLocale:title'))}</h1>
                </div>
              </div>
            </InView>
            <div className="page__content">
              <section className="container container--m gutter--3-2">
                <ul className="locales__list blocklist">
                  {allLanguages.map((locale) => (
                    <li className="locales__item blocklist__item">
                      <a
                        className="blocklist__link"
                        href={oldSites.get(locale) || `/${locale == 'global' ? '' : locale}`}
                        onClick={(e) => {
                          setCookie('locale', locale == 'global' ? 'en' : locale, 1000)
                          switchLanguageDatalayer(localeTranslations.get(locale), window.location.pathname)
                        }}
                      >
                        <span lang={localeISOcodes.get(locale)}>{localeTranslations.get(locale)}</span>
                        {locale === 'global' ? (
                          <svg className="blocklist__icon" width="1.5rem" height="1.5rem" aria-hidden="true">
                            <use xlinkHref="#icon--global" />
                          </svg>
                        ) : (
                          <img className="blocklist__image" alt="" src={`./images/flags/${locale}.jpg`} />
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </section>
            </div>
          </div>
        </article>
      </div>
    </main>
  </>
)
